import { render } from "./CmsZenShield.vue?vue&type=template&id=3d11fd36&lang=html"
import script from "./CmsZenShield.vue?vue&type=script&lang=js"
export * from "./CmsZenShield.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__